import React from 'react';
import { StyleSheet } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

export const MenuIcon = ({ as, name, size = defaultScale(24),customStyle }) => {
  const Comp = as || Icon
  return (
    <Comp
      size={size}
      style={[styles.icon,customStyle]}
      color={Theme.GREY_DARK}
      name={name}
    />
  );
};

const styles = StyleSheet.create({
  icon: {
    alignSelf: 'center',
  },
});
